// extracted by mini-css-extract-plugin
module.exports = {"section":"section__2JM6T","steps":"steps__3H36P","step-header":"step-header__TR6K8","step":"step__1U7Nt","arrow":"arrow__QIVkC","footer":"footer__30uLs"};